import { render } from "./Main.vue?vue&type=template&id=6daafa9a"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=6daafa9a&lang=css"

import exportComponent from "D:\\网页文件\\新闻网专题\\2023ZT\\Fzsp\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__